export default "__VITE_ASSET__a962a5eb__"